import { ChangeEvent, useCallback } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PolicyForm } from '../policy-dialog';

import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

interface PolicyManagerEmailTextFieldProps {
  watch: UseFormWatch<PolicyForm>;
  setValue: UseFormSetValue<PolicyForm>;
  disabled: boolean;
  fieldName: `actionData.${number}.userModelTemplate.relations`;
}

export default function PolicyManagerEmailTextField({
  watch,
  setValue,
  disabled,
  fieldName,
}: PolicyManagerEmailTextFieldProps) {
  const relations = watch(fieldName);

  const handleManagerEmailChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const managers =
        relations?.filter((relation) => relation.type === 'manager') || [];
      const hasManagers = managers.length > 0;

      if (hasManagers) {
        if (e.target.value === '' && managers.length === 1) {
          setValue(
            fieldName,
            relations?.filter((relation) => relation.type !== 'manager'),
            { shouldDirty: true }
          );
          return;
        } else {
          let foundManager = false;
          setValue(
            fieldName,
            relations?.map((relation) => {
              if (relation.type === 'manager' && !foundManager) {
                foundManager = true;
                return { ...relation, value: e.target.value };
              }
              return relation;
            }),
            { shouldDirty: true }
          );
        }
      } else {
        setValue(
          fieldName,
          [
            ...(relations || []),
            {
              type: 'manager',
              customType: '',
              value: e.target.value,
            },
          ],
          { shouldDirty: true }
        );
      }
    },
    [relations, setValue, fieldName]
  );

  return (
    <Tooltip
      arrow
      title={
        disabled
          ? `You need the "Edit Relationships" permission to edit this field.`
          : ''
      }
    >
      <span>
        <TextField
          value={relations?.find((rel) => rel.type === 'manager')?.value || ''}
          onChange={(e) => handleManagerEmailChange(e)}
          autoComplete="off"
          label="Manager's Email"
          sx={{ minWidth: 400 }}
          disabled={disabled}
        />
      </span>
    </Tooltip>
  );
}
